export { default } from "./slugMiddleware";
